import {
  Stack,
  Typography,
  IconButton,
  Grid,
  SvgIcon,
  Box,
} from "@mui/material";
import { NumberInput, Switch } from "../../../../utils/form";
import _ from "lodash";
import { Close as CloseIcon } from "@mui/icons-material";
import SelectedMedicine from "./SelectedMedicine";
import TemplateContentPicker from "../templates/ContentPicker";
import VademecumInput from "../../../prescriptions/new/form/medicine/vademecum";
import ManualInput from "./ManualInput";
import { useEffect } from "react";

const RemoveButton = ({
  form,
  name,
  index,
  remove,
  fields,
  setSelectedTemplate,
  method,
  defaultMedicine,
  lengthMedicines,
}) => {
  const onClick = () => {
    setSelectedTemplate(null);
    if (fields.length === 1) {
      form.resetField(name, { defaultValue: _.cloneDeep(defaultMedicine) });
    } else {
      remove(index);
    }
  };

  const disabled =
    lengthMedicines === 1 ? method === "manual" && index === 0 : false;

  return (
    <IconButton onClick={onClick} disabled={disabled}>
      <SvgIcon sx={{ fontSize: 18 }}>
        <CloseIcon />
      </SvgIcon>
    </IconButton>
  );
};

const DuplicatedCheckbox = ({ form, name }) => {
  return (
    <Switch
      form={form}
      name={`${name}.requiresDuplicate`}
      label="Duplicado"
      size={10}
    />
  );
};

const GenericOnlyCheckbox = ({ form, name }) => {
  const brandRecommendation = form.watch(`${name}.brandRecommendation`);
  useEffect(() => {
    if (brandRecommendation) {
      form.setValue(`${name}.genericOnly`, false);
    }
  }, [brandRecommendation, form, name]);

  return (
    <Switch
      form={form}
      name={`${name}.genericOnly`}
      label="Sólo genérico"
      size={10}
    />
  );
};

const BrandRecommendationCheckbox = ({ form, name }) => {
  const genericOnly = form.watch(`${name}.genericOnly`);
  useEffect(() => {
    if (genericOnly) {
      form.setValue(`${name}.brandRecommendation`, false);
    }
  }, [genericOnly, form, name]);

  return (
    <Switch
      form={form}
      name={`${name}.brandRecommendation`}
      label="Recomendar marca"
      size={10}
    />
  );
};

const QuantitySumAndRest = ({ form, name }) => {
  return <div style={{ width: "max-content" }}>
    <NumberInput form={form} name={`${name}.quantity`} max={15} />
  </div>
};

const CardSeleted = ({ ...props }) => {
  const {
    form: { getValues },
    name,
    method,
    templateType,
    defaultTemplateText
  } = props;
  const selectedMedicineText = getValues(`${name}.text`);
  const selectedTemplateText = getValues(`${name}.template`)?.name || defaultTemplateText;

  return (
    <Stack
      sx={{
        backgroundColor:
          (selectedMedicineText || selectedTemplateText) && "lightBlue.main",
        borderRadius: 3,
        p: 2,
      }}
    >
      {(selectedMedicineText || selectedTemplateText) && (
        <>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{ fontWeight: 500, color: "secondary.main", fontSize: 12 }}
            >
              {method === "manual" && selectedTemplateText}
              {method === "vademecum" && selectedMedicineText}
            </Typography>
            <RemoveButton {...props} />
          </Stack>
          <Stack sx={{ mt: 1, mb: 1 }}>
            {method === "vademecum" && <SelectedMedicine {...props} />}
            {method === "manual" && <ManualInput {...props} />}
          </Stack>
        </>
      )}

      {method === "manual" &&
        (selectedTemplateText === "Nuevo medicamento" ||
          selectedTemplateText === "Nueva solicitud" ||
          !selectedTemplateText ||
          (selectedTemplateText !== "Nuevo medicamento" &&
            selectedTemplateText !== "Nueva solicitud" &&
            !selectedMedicineText)) && <TemplateContentPicker {...props} />}
      {method === "vademecum" && !selectedMedicineText && (
        <VademecumInput {...props} />
      )}

      {(selectedMedicineText || selectedTemplateText) &&
        templateType === "prescription" && (
          <Grid container alignItems="center">
            {method === "vademecum" && (
              <Grid item xs={12} sm={3} md={6} lg={6} xl={3}>
                <QuantitySumAndRest {...props} />
              </Grid>
            )}

            <Grid item xs={6} sm={3} md={6} lg={6} xl={3}>
              <DuplicatedCheckbox {...props} />
            </Grid>

            {method === "vademecum" && (
              <Grid item xs={6} sm={3} md={6} lg={6} xl={3}>
                <GenericOnlyCheckbox {...props} />
              </Grid>
            )}

            {method === "vademecum" && (
              <Grid item xs={12} sm={3} md={6} lg={6} xl={3}>
                <BrandRecommendationCheckbox {...props} />
              </Grid>
            )}
          </Grid>
        )}
    </Stack>
  );
};

export default CardSeleted;
